/* eslint-disable import/prefer-default-export */

export const TYPE = {
    SMS_RECEIVED: 'SMS_RECEIVED',
    EMAIL_RECEIVED: 'EMAIL_RECEIVED',
    REMINDER_EVENT: 'REMINDER_EVENT',
    REMINDER_CALL: 'REMINDER_CALL',
    REMINDER_TASK: 'REMINDER_TASK',
};
